import React, { } from 'react';
import ImageRound from '../../ImageRound';
import { comprobarAvatar } from '@/util/Articulos';
import { dateToText, obtenerHora } from '@/util/MagicDate';
import { azulClaro, primary, white } from '@/constants/Colors';
import Texto from '../../Texto';
import { Card } from '@mui/material';
import { textosMini } from '@/constants/Dimens';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { useTranslation } from 'next-i18next';
import { MensajeChat_ChatBot } from '@/objects/ChatBot';
import { useNotificationContext } from '@/context/NotificationContext';
import { filtraLink } from '@/util/StringsUtil';

interface Props {
  mensaje: MensajeChat_ChatBot;
}

const RowMensajeChatBot: React.FC<Props> = ({ mensaje }) => {
  const { t } = useTranslation();

  const { userData } = useNotificationContext();

  const [uniqueId] = React.useState<number>(Date.now());

  const id_autor = mensaje.id_autor;
  const autor_yo = id_autor == userData?.id_user;
  const imagen_usuario = mensaje.imagen_usuario;
  const texto = mensaje.texto;
  const fecha = mensaje.fecha;

  const styles: { [key: string]: React.CSSProperties } = {
    contenedorImagenChat: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      margin: 5,
    },
    contenedorChatDerecha: {
      flex: 12,
      backgroundColor: primary,
      borderRadius: 12,
      margin: 5,
      padding: "20px",
      alignItems: "flex-end",
      justifyContent: "center"
    },
    contenedorChatIzquierda: {
      flex: 12,
      backgroundColor: white,
      borderRadius: 15,
      margin: 5,
      padding: "20px",
      alignItems: "flex-start",
      justifyContent: "center",
    },
    textoChat: {
      color: 'white',
      fontSize: 16,
      fontWeight: "300",
    },
    fechaChat: {
      color: 'white',
      fontSize: 10,
      fontWeight: "300",
    },
    contenedorExtraChat: {
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    filaChatDerecha: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "flex-end",
      width: "600px",
    },
    filaChatIzquierda: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "600px",
    },
  }

  return (
    <article key={uniqueId} style={{
      width: '100%', display: 'flex', justifyContent: autor_yo ? 'flex-end' : 'flex-start',
      marginBottom: "10px"
    }}>
      <div style={autor_yo ? styles.filaChatDerecha : styles.filaChatIzquierda}>
        {autor_yo ? (
          <>
            <Card style={styles.contenedorChatDerecha}>
              <Texto color={white}>{texto}</Texto>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <DoneAllIcon
                  style={{
                    color: azulClaro,
                    width: "15px",
                    height: "15px",
                    marginRight: "3px"
                  }}
                />
                <Texto fontSize={textosMini} color={white}>
                  {dateToText(fecha!, t) + " " + obtenerHora(fecha!)}
                </Texto>
              </div>
            </Card>
            <div style={{ ...styles.contenedorImagenChat }}>
              <ImageRound
                src={comprobarAvatar(imagen_usuario)}
                title={t("contenido:user.card_user.title_user")}
                alt={"contenido:user.card_user.alt_user"}
              />
            </div>
          </>
        ) : (
          <>
            <div style={{ ...styles.contenedorImagenChat }}>
              <ImageRound
                src={comprobarAvatar(String(imagen_usuario))}
                title={t("contenido:user.card_user.title_user")}
                alt={"contenido:user.card_user.alt_user"}
              />
            </div>
            <Card style={styles.contenedorChatIzquierda}>
              <Texto html color={primary}>{filtraLink(texto)}</Texto>
              <div>
                <Texto fontSize={textosMini} color={primary}>
                  {dateToText(fecha!, t) + " " + obtenerHora(fecha!)}
                </Texto>
              </div>
            </Card>
          </>
        )}
      </div>
    </article>
  );
};

export default RowMensajeChatBot;